import { isAvailable } from "@Pages/Search/components/SearchListItem/helper";
import getStringFromCount from "./getStringFromCount";

const getDuration = (formData: any, inventoryData: any) => {
  const availableRooms = inventoryData?.active_children?.filter((config: any) =>
    isAvailable(config),
  );
  const nonFlexibleTenancyDuration = getStringFromCount(
    availableRooms
      ?.find((r: any) => +r.id === +formData?.roomType)
      ?.active_children?.find((t: any) => +t.id === +formData.tenancyId)?.meta?.lease_duration,
    "week",
  );
  return (
    formData?.custom_duration ||
    (formData?.duration === "flexible" ? "" : formData?.duration || nonFlexibleTenancyDuration)
  );
};

export const getNonFlexibleTenancyDuration = (formData: any, inventoryData: any) => {
  const availableRooms = inventoryData?.active_children?.filter((config: any) =>
    isAvailable(config),
  );
  const meta = availableRooms
    ?.find((r: any) => +r.id === +formData?.roomType)
    ?.active_children?.find((t: any) => +t.id === +formData.inventory_id)?.meta;

  const nonFlexibleTenancyDuration = getStringFromCount(
    meta?.lease_duration,
    meta?.lease_duration_unit,
  );
  return nonFlexibleTenancyDuration;
};

export default getDuration;
